var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _class, _class2, _descriptor, _descriptor2, _descriptor3;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Component, Prop, Event, html } from '@sick-davinci/ce-decorators';
import { style } from './PopupList.style';
/**
 * Single popup list item.
 */

export class PopupListItem {
  constructor(value, presentation) {
    this.presentation = presentation;
    this.value = value;
  }

}
/**
 * A `davinci-popup-list` is a list that can be revealed.
 * @deprecated will be removed in version 6.0.0
 * @example
 * ```html
 * <davinci-popup-list></davinci-popup-list>
 * <script>
 *     let elem = document.querySelector('davinci-popup-list');
 *     elem.addItem("One", "1");
 *     elem.addItem("Two", "2");
 *     elem.addItem("Three", "3");
 *     elem.addEventListener("itemclick", (event)=>{
 *         console.log(elem.getSelectedItem());
 *     } );
 * </script>
 * ```
 * 
 * ## Methods
 * ==
 * | Definition | Description |
 * | - | - |
 * | addItem(presentation: string, value: string) | adds a new item to the popup list |
 * | resetItems() | removes all items from the list |
 * | setList(list: Array<PopupListItem>) | sets a full list to the popup list |
 * | getSelectedItem() | returns the value of the selected item |
 */

export let PopupList = (_dec = Component({
  tag: 'davinci-popup-list',
  style: [style]
}), _dec2 = Reflect.metadata("design:paramtypes", []), _dec3 = Prop(), _dec4 = Reflect.metadata("design:type", Boolean), _dec5 = Prop(), _dec6 = Reflect.metadata("design:type", Boolean), _dec7 = Prop(), _dec8 = Reflect.metadata("design:type", Number), _dec9 = Event(), _dec10 = Reflect.metadata("design:type", Object), _dec(_class = _dec2(_class = (_class2 = class PopupList extends CustomElement {
  /**
   * Specifies that the upper border is not visible.
   */

  /**
   * Specifies that the popuplist should be visible.
   */

  /**
   * Position of the selected item.
   */
  set index(i) {
    this._selected = i > -1 && i < this._listContent.length ? i : -1;
  }

  get index() {
    return this._selected;
  }
  /**
   * Emitted if an item is clicked. Returns the index of the clicked item. Index starts at 0.
   */


  constructor() {
    super();

    _initializerDefineProperty(this, "opentop", _descriptor, this);

    _initializerDefineProperty(this, "show", _descriptor2, this);

    _initializerDefineProperty(this, "itemclick", _descriptor3, this);

    this._listContent = new Array();
    this._selected = -1;
  }

  addItem(presentation, value) {
    this._listContent.push(new PopupListItem(value, presentation));

    this.scheduleRender(true);
  }

  resetItems() {
    this._listContent.splice(0, this._listContent.length);

    this.scheduleRender(true);
  }

  setList(list) {
    this._listContent = list;
    this.scheduleRender(true);
  }

  getSelectedItem() {
    return this._selected > -1 && this._selected < this._listContent.length ? this._listContent[this._selected].value : '';
  }

  render() {
    return html`
        ${this._listContent.map((item, idx) => html`
        <div id=${this._selected === idx ? 'activeitem' : ''}
          class='item'
          @mousedown=${e => this._handleClick(idx, e)
    /*use mousedown to prevent focuslost*/
    }>
          ${!!item.presentation ? item.presentation : item.value}
        </div>`)}
    `;
  }

  _handleClick(idx, e) {
    e.preventDefault();
    this.index = idx;
    this.itemclick.emit(idx);
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "opentop", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "show", [_dec5, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "index", [_dec7, _dec8], Object.getOwnPropertyDescriptor(_class2.prototype, "index"), _class2.prototype), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "itemclick", [_dec9, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class) || _class);
